<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/electronics/wuxi/wx.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    电子无锡工厂
                </div>
                <div class="manufacture-t2">
                    位于无锡市锡山经济技术开发区，聚焦于 Si IGBT & SiC MOS 的研发与创新，核心技术自主可控，联合产业链上下游，深度布局芯片设计和模组封测全环节。<br />
                    拥有无锡第三代半导体研发及生产基地、保定应用中心，其中无锡第三代半导体模组封测制造基地建筑面积约 30000㎡，规划车规级模组年产能 120 万套。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                IGBT前道
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                芯片贴片
                            </div>
                            <div class="destils">
                                采用业界领先的贴片系统<br />
                                贴片精度高，贴装压力精准可控，可实现IGBT/FRD不同Wafer尺寸晶圆贴片<br />
                                焊带裁切系统可实现焊带的高精度裁切<br />
                                智能化程度高，可实现芯片精准追溯
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                芯片焊接
                            </div>
                            <div class="destils">
                                来自行业内技术领先的德国pink公司<br />
                                是一种独特的三腔式真空焊接炉，其高真空度和甲酸结合使用可以防止材料氧化并激<br />
                                活界面，能降低芯片焊接的空洞率，降低热阻，提高可靠性和良品率<br />
                                其工艺能力可以对标行业标杆英飞凌
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                键合
                            </div>
                            <div class="destils">
                                来自行业领先的德国HESSE公司的粗铜铝线键合机，可以键合线径100~600um的引线<br />
                                采用世界范围内最先进的冷超声大功率键合机，确保粗铜线和粗铝线稳定的键合工艺，工艺过程稳定性极高，每一个焊点以每毫秒采样一次过程数据，并行成建和过程的数据完全监控，并形成实时图表<br />
                                可以直观地反应键合过程的稳定性和异常点
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-3.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                热贴
                            </div>
                            <div class="destils">
                                设备由日本松下半导体装备公司设计最新代的SIC芯片贴装专用设备， 它在传统的贴片头设计了超声波单元，经DOE定义的恰当的超声波能量通过贴片头传递到芯片和银膏层的结合面， 使其快速形成芯片奇数层与银的微结合。这大大提高了UPH， 单颗芯片的CT可达3S, 是传统贴片机的20%
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-4.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                烧结
                            </div>
                            <div class="destils">
                                采用当前技术最前沿的独立压头的银烧结技术，同一衬板的不同芯片的烧结强度一致性好
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx1-5.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                灌封后道
            </div>
            
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                系统焊接
                            </div>
                            <div class="destils">
                                来自行业内技术领先的德国pink公司<br />
                                是一种独特的四腔式真空焊接炉，其高真空度和甲酸结合使用可以防止材料氧化并激活界面，能降低系统焊接层的空洞率，降低热阻，提高可靠性和良品率<br />
                                其工艺能力可以对标行业标杆英飞凌
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                端子超声焊
                            </div>
                            <div class="destils">
                                来自行业领先的德国Schunk公司<br />
                                采用当前最世界最先进的驻波大功率超声波端子焊接技术，相比于传统的超声波型它的焊接过程减少焊接压力对产品陶瓷板的损伤，提高产品的可靠性和良品率
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                成品测试
                            </div>
                            <div class="destils">
                                该设备来自技术领先的意大利测试设备供应商SPEA，专门为满足大功率模块测试而设计，稳定性好<br />
                                可满足IGBT半桥/全桥以及SIC全桥和半桥模块的高低温动态测试、常温静态测试、绝缘测试、在线RB老化测试，并集成激光打标和自动剔除不良品等功能
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                塑封后道
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                塑封
                            </div>
                            <div class="destils">
                                全自动塑封设备，通过转模的方式用塑封料将产品进行塑封，为功率模块提供物理保护<br />
                                可实现精准压力、温度控制，可适应多种环氧塑封料<br />
                                空洞和分层控制可达业界领先水平
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                HTXB
                            </div>
                            <div class="destils">
                                超宽温域，兼容HTRB和HTGB，可精准筛选功率模块芯片级早期失效<br />
                                采用行业最先进的热板式老化架构，较传统的温箱式老化设备效率提升20%以上
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/wuxi/wx3-2.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '电子无锡工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/el/wuxi.html'
};

import { createApp } from 'vue';
import App from './wuxi.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./wuxi.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
